import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import CustomToast from "./components/Toast";
import ProtectedRoutes from "./routes";
import AuthGuard from "./routes/AuthGuard";
import { PrivateRoutes } from "./routes/routes";
import { Loader } from "./components/Loader";

// Lazy load route components
const Login = lazy(() => import("./pages/Login"));
const NotFound = lazy(() => import("./pages/404"));
const Signup = lazy(() => import("./pages/Signup"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const InviteDetails = lazy(() => import("./views/OnBoarding/InviteDetails"));
const ProjectsDashboard = lazy(() => import("./views/Projects"));
const Projects = lazy(() => import("./views/Projects/Projects"));
const BuildLogs = lazy(() => import("./views/Projects/BuildLogs"));
const CustomDomain = lazy(() => import("./views/Projects/CustomDomain"));
const ProjectSettings = lazy(() => import("./views/Projects/ProjectSettings"));
const SetupProfile = lazy(() => import("./views/OnBoarding/SetupProfile"));

export default function App() {
  return (
    <BrowserRouter>
      <Loader />
      <CustomToast />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="*" element={<NotFound />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/invite-details" element={<InviteDetails />} />

          <Route element={<AuthGuard />}>
            <Route path="/setup-profile" element={<SetupProfile />} />
          </Route>
          <Route element={<ProtectedRoutes />}>
            <Route path="/projects" element={<ProjectsDashboard />} />
            <Route path="/project/:id" element={<Projects />} />
            <Route path="/project/:id/build-logs" element={<BuildLogs />} />
            <Route
              path="/project/:id/custom-domain"
              element={<CustomDomain />}
            />
            <Route path="/project/:id/settings" element={<ProjectSettings />} />
            {PrivateRoutes.map((route, index) => (
              <React.Fragment key={index}>
                <Route path={route.path} element={route.element} />
                {route.subMenu &&
                  route.subMenu.map((menu, i) => (
                    <Route path={menu.path} element={menu.element} key={i} />
                  ))}
              </React.Fragment>
            ))}
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
